import HeadsUpBanner from './HeadsUpBanner';

export default HeadsUpBanner;
